import { GenericDatabase } from './GenericDatabase'

const DB_NAME = 'User'
const DB_VERSION = 1
const STORE_NAME = 'myUser'

const dbInstance = new GenericDatabase(DB_NAME, DB_VERSION, [
    { name: STORE_NAME, keyPath: '_id' }
])

const initDb = () => {
    return dbInstance.init()
}

const agregar = (data, database) => {
    return dbInstance.add(STORE_NAME, data, database)
}

const obtener = (clave, database) => {
    return dbInstance.get(STORE_NAME, Number(clave), database)
}

const consultarPorDato = (dato, database) => {
    // Original implementation was incomplete/empty.
    // Keeping the signature but returning a promise that resolves to null or empty to mimic behavior,
    // or we could implement a search if we knew what 'dato' matches.
    // Since original did nothing useful (opened cursor but no logic), we return a safe promise.
    return new Promise(resolve => resolve(null))
}

const actualizar = (data, database) => {
    return dbInstance.put(STORE_NAME, data, database)
}

const eliminar = (clave, database) => {
    return dbInstance.delete(STORE_NAME, clave, database)
}

const consultar = (database) => {
    return dbInstance.getAll(STORE_NAME, database)
}

export default {
    initDb,
    agregar,
    obtener,
    actualizar,
    eliminar,
    consultar,
    consultarPorDato
}
